import React, {FC, useState, useEffect} from "react";
import { useQueryParam, StringParam, NumberParam } from 'use-query-params';
import { StartPage } from "../../../components";
import { billingService } from "../../../api";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../utils/display-price";
import { icons } from "../../../icons";
import { useNavigate } from "react-router-dom";
import { usePageTitle } from "../../../context/navigationContext";

const Gateways:FC = () => {
  const [page, setPage] = useQueryParam('page', NumberParam);
  const [ordering, setOrdering] = useQueryParam('ordering', StringParam);
  const [pageSize, setPageSize] = useQueryParam('page_size', NumberParam);
  const [searchString, setSearchString] = useQueryParam('search', StringParam);
  const [paginationData, setPaginationData] = useState<any>()
  const [invoices, setInvoices] = useState<any[]>([])
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [t] = useTranslation()
  usePageTitle(t("PAGE_TITLE_GATEWAYS"));
  const navigate = useNavigate()
  const getInvoices = () => {
    billingService.getGateways({
      page:page || 1,
      page_size:pageSize || 20,
      search:searchString||''
    })
    .then((res) => {
      setInvoices(res.data.objects.map((invoice:any) => {
        return {
          ...invoice,
          navigate:invoice.id.toString(),
          enabled:invoice?.enabled ? t("YES") : t("NO"),
          name:invoice?.display_name,
          total:formatCurrency(invoice.total, invoice.currency),
        }
      }))
      setPaginationData(res.data)
      setPageLoading(false)
    })
    .catch((e) => {
      console.log('error', e);
      setPageLoading(false)
    })
  }
  useEffect(() => {
    getInvoices()
    const interval = setInterval(() => {
      getInvoices()
    }, 5000)
    return () => {
      clearInterval(interval)
    }
  },[page,
    ordering,
    pageSize,
    searchString])
  const ColumnsInvoices = [
    {
      title:t("NAME"),
      key:'name'
    },
    {
      title:t("ENABLED"),
      key:'enabled',
    },
    {
      title:t("FIXED_FEE"),
      key:'fixed_fee',
    },
    {
      title:t("PERCENT_FEE"),
      key:'percent_fee',
    },
    {
      title:'',
      key:'props'
    }
  ]
  const contextMenu = [
    {
      title:t("EDIT"),
      id:'3',
      icon:icons.Edit,
      onClick: (item:any) => {
        navigate(`${item.id}/edit`)
      },
      divider:false
    }
  ]
  
  return (
    <>
      <StartPage
        title={`${t("GATEWAYS")}`}
        noResourceText={`${t("NO_GATEWAYS")}`}
        haveResource={invoices.length > 0}
        pageLoading={pageLoading}
        tableData={{
          columns:ColumnsInvoices,
          data:invoices,
          hideCheckbox:true,
          props:contextMenu,
          paginationData:paginationData,
          updateData:getInvoices
        }}
      />
    </>
  )
}

export default Gateways

